import React, { forwardRef } from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Badge from "react-bootstrap/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faStop, faEye, faEyeSlash, faUser } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Logo } from "../Header/logo.svg";
import { getUserEvents, getUserEventsWebSocketUrl } from "../../../libs/dashboard";
import { useStreamEvents } from "../../../hooks/useStreamEvents";

const UserEvents = forwardRef(({ userId, setEvents, setEventsByRequestId, onToggleVisibility, onRefresh, onHomeChange }, ref) => {
    const { isConnected, isConnecting, isLoading, showEvents, handleToggleEvents, connect, disconnect } = useStreamEvents({
        clientId: userId,
        fetchEvents: getUserEvents,
        getWebSocketUrl: (clientId) => getUserEventsWebSocketUrl(clientId),
        defaultSource: 'user',
        visibilityKey: '__user__',
        setEvents,
        setEventsByRequestId,
        onToggleVisibility,
        onRefresh,
        onHomeChange,
        ref,
    });

    return (
        <div className="d-inline-flex align-items-center gap-2 border rounded px-2 py-1 me-2">
            {/* Bond logo — always blue, animates with loading/connected state */}
            <div
                className={`d-flex align-items-center justify-content-center ${(isConnecting || isLoading) ? 'fa-shake' : isConnected ? 'fa-beat-fade' : ''}`}
                style={{
                    width: '24px',
                    height: '24px',
                    filter: 'brightness(0) saturate(100%) invert(29%) sepia(93%) saturate(1352%) hue-rotate(213deg) brightness(97%) contrast(97%)',
                }}
            >
                <Logo width={24} height={24} />
            </div>

            {/* User label */}
            <Badge className="integrationBadge" style={{ '--integration-badge-bg': '#8da9c4', '--integration-badge-color': '#1c2b3a', fontSize: '0.75rem' }}>
                <FontAwesomeIcon icon={faUser} className="me-1" />
                User
            </Badge>

            {/* Play/stop + visibility buttons for user stream */}
            <ButtonGroup size="sm">
                <Button
                    variant={isConnected ? "danger" : "outline-success"}
                    disabled={isConnecting || isLoading}
                    onClick={() => { if (isConnected) disconnect(); else if (!isConnecting) connect(); }}
                    className="p-0 d-flex align-items-center justify-content-center"
                    style={{ width: '32px', height: '32px', minWidth: '32px' }}
                    title={isConnected ? 'Stop live user stream' : 'Start live user stream'}
                >
                    <FontAwesomeIcon icon={isConnected ? faStop : faPlay} size="sm" />
                </Button>

                <Button
                    variant={showEvents ? "outline-primary" : "outline-secondary"}
                    onClick={handleToggleEvents}
                    className="p-0 d-flex align-items-center justify-content-center"
                    style={{ width: '32px', height: '32px', minWidth: '32px', zIndex: 2 }}
                    title={showEvents ? 'Hide user events' : 'Show user events'}
                >
                    <FontAwesomeIcon icon={showEvents ? faEye : faEyeSlash} size="sm" />
                </Button>
            </ButtonGroup>
        </div>
    );
});

UserEvents.displayName = 'UserEvents';

export default UserEvents;
